import { checkName } from "aic";
import { ISaveBlocker } from "./interface";

/**
 * Validates an ARS object's name and builds its save blocker when invalid.
 *
 * @template T - An ARS object type with an identifier and name.
 * @param item - The ARS object whose name is being validated.
 * @param collection - The objects in the same collection, used to detect duplicate names.
 * @param itemType - The display name used in the save-blocker warning.
 * @returns The save blocker for an invalid name, or undefined when the name is valid.
 */
export const getArsObjectNameSaveBlocker = async <T extends { id: string; name: string }>(
  item: T,
  collection: T[],
  itemType: "Analysis method" | "Analysis set" | "Data subset" | "Grouping factor",
): Promise<ISaveBlocker | undefined> => {
  const result = await checkName(
    "",
    {
      value: item.name,
      options: {
        existingValues: collection
          .filter((existing) => existing.id !== item.id)
          .map((existing) => existing.name),
      },
    },
    new AbortController(),
  );

  if (!result.success || !result.data.valid) {
    return {
      id: item.id,
      type: "arsObjects",
      warningText: `${itemType} ${item.name} is invalid.`,
    };
  }

  return undefined;
};
